module.exports = __webpack_public_path__ + "img/cvx.b6bd0eb2.svg";